// @ts-nocheck
/* eslint-disable */
import { _ } from "~/route/globals";
import { createParamsItemTollItem } from "./item.toll.item";
import { buildRadioCheck, icon, node, text } from "~/util/dom";
import { ROUTE_CONST } from "~/route/const";

export default class ParamsItemToll {
	_openState: boolean;

	_container: ReturnType<typeof buildRadioCheck>;

	_containerMulti: HTMLDivElement;

	_iconClosed: SVGSVGElement | HTMLSpanElement;

	_iconOpen: SVGSVGElement | HTMLSpanElement;

	_popup: HTMLDivElement;

	constructor(type) {
		this._openState = false;
		this._container = buildRadioCheck("checkbox", type.name || "", type.label);
		this._containerMulti = node("div", { className: "toll" });
		this._iconClosed = icon("forward");
		this._iconOpen = icon("dropdown");
		this._containerMulti.appendChild(this._iconClosed);
		this._containerMulti.appendChild(text(type.label));
		this._popup = node("div", { className: "popup" });
		this._countryData = [];
		this._excludeCountries = [];
		this._avoidAllInput = null;

		this._container.label.classList.add("toll");

		Mapy.CML.addListener((request, state, fromRestore) => {
			if (fromRestore || !state.route.responseData[state.route.index] || request) {
				return;
			}
			this._countryData = state.route.responseData[state.route.index].countryData;
			this._build();
		}, "route.request");

		Mapy.CML.addListener((index, state) => {
			if (!state.route.responseData[state.route.index]) {
				return;
			}
			this._countryData = state.route.responseData[state.route.index].countryData;
			this._build();
		}, "route.index");

		Mapy.CML.addListener((clear) => {
			if (clear) {
				this._countryData = [];
				this._excludeCountries = [];
				this._build();
			}
		}, "route.clear");

		document.body.addEventListener("click", this, false);
	}

	destroy() {
		document.body.removeEventListener("click", this, false);
	}

	get label() {
		return this._container.label;
	}

	get input() {
		return this._container.input;
	}

	get title() {
		return this._container.title;
	}

	get excludeCountries() {
		return this._excludeCountries;
	}

	get avoidAll() {
		return this._avoidAllInput ? this._avoidAllInput.checked : false;
	}

	handleEvent(e) {
		if (this._popup.contains(e.target)) {
			//
		} else if (this._containerMulti.contains(e.target)) {
			if (this._openState) {
				this._hidePopup();
			} else {
				this._showPopup();
			}
		} else if (this._container.label.contains(e.target) && !this._container.label.classList.contains('show-avoid-paids')) {
			this._container.input.dispatchEvent(new CustomEvent("toll-change"));
		} else if (this._openState) {
			this._hidePopup();
		}
	}

	_build() {
		if (this._countryData.length > 1 && Mapy.CML.state.route.params.type === ROUTE_CONST.TYPE_CAR) {
			this._popup.innerHTML = "";

			// vsechny checkboxy u statu
			const allChkbxs = [];

			// vyhnout se vsem
			const avoidAll = node("div", { className: "avoid-all checkbox-item" });
			const avoidAllData = buildRadioCheck("checkbox","", "");

			avoidAllData.title.appendChild(node("p", { className: "title", textContent: _("route.params.avoidAll") }));
			avoidAllData.input.addEventListener("change", (e) => {
				let ex = this._countryData.map(i => {
					return i.iso3
				});

				allChkbxs.forEach(i => {
					i.checked = avoidAllData.input.checked;
				});

				this._excludeCountries = avoidAllData.input.checked ? ex : [];
				this._container.input.checked = avoidAllData.input.checked;

				this._container.input.dispatchEvent(new CustomEvent("toll-change"));
			});
			this._avoidAllInput = avoidAllData.input;
			avoidAll.appendChild(avoidAllData.label);
			this._popup.appendChild(avoidAll);

			// oddelovac
			const separator = node("div", { className: "separator" });

			this._popup.appendChild(separator);

			// list pro staty
			let countryList = node("ul", { className: "country-list" });
			let lastChoiceItems = [];
			let criterion = Mapy.CML.state.route.params.criterion;
			let excludeCountries = Mapy.CML.state.route.params.excludeCountries;

			let inputChange = (data, item) => {
				if (item.input.checked) {
					if (this._excludeCountries.indexOf(data.iso3) == -1) {
						this._excludeCountries.push(data.iso3);
					}
				} else {
					const index = this._excludeCountries.indexOf(data.iso3);

					if (index > -1) {
						this._excludeCountries.splice(index, 1);
					}
					avoidAllData.input.checked = false;
					this._container.input.checked = avoidAllData.input.checked;
				}

				let checked = allChkbxs.filter(a => { return a.checked; });

				if (allChkbxs.length == checked.length) {
					avoidAllData.input.checked = true;
					this._container.input.checked = avoidAllData.input.checked;
				}

				this._container.input.dispatchEvent(new CustomEvent("toll-change"));
			}

			// payedLength x totalLength
			this._countryData.forEach(function(data) {
				if (data.totalLength === 0) {
					lastChoiceItems.push(data);
				} else {
					const newItem = createParamsItemTollItem(data, true);

					newItem.input.addEventListener("change", e => {
						inputChange(data, newItem);
					});

					allChkbxs.push(newItem.input);
					countryList.appendChild(newItem.li);
				}
			}, this);

			this._popup.appendChild(countryList);

			if (criterion === 111 || criterion === 113) {
				avoidAllData.input.checked = excludeCountries.length === this._countryData.length;
			} else {
				avoidAllData.input.checked = true;

				if (this._excludeCountries.length === 0 && this._countryData.length) {
					this._countryData.forEach(cd => {
						this._excludeCountries.push(cd.iso3);
					});

					Mapy.CML.state = {
						route: {
							params: {
								excludeCountries: this._excludeCountries,
							},
						},
					};
				}
			}
			if (lastChoiceItems.length) {
				countryList.classList.add("with-last-choice");

				// predchozi vyber
				let lastChoice = node("p", { className: "last-choice-title", textContent: _("route.params.lastChoice") });
				this._popup.appendChild(lastChoice);

				let lastChoiceList = node("ul", { className: "last-choice-list" });

				// seradime je
				lastChoiceItems.sort((a, b) => {
					if (a.name === b.name) return 0;
					if (a.name > b.name) return 1;
					if (a.name < b.name) return -1;
				});

				// vytvorime je
				lastChoiceItems.forEach(data => {
					const lItem = createParamsItemTollItem(data);

					lastChoiceList.appendChild(lItem.li);
					lItem.input.addEventListener("change", e => {
						inputChange(data, lItem);
					});

					allChkbxs.push(lItem.input);
				});

				this._popup.appendChild(lastChoiceList);
			}

			this._containerMulti.appendChild(this._popup);
		} else if (Mapy.CML.state.route.params.type === ROUTE_CONST.TYPE_CAR) {
			const criterion = Mapy.CML.state.route.params.criterion;

			this._container.input.checked = !(criterion === 111 || criterion === 113);
		}

		this._container.label.classList[this._countryData.length > 1 ? "add" : "remove"]("show-avoid-paids");
		if (this._countryData.length > 1) {
			//this._container.input.remove();
			if (this._container.label.parentNode) {
				this._container.label.replaceWith(this._containerMulti);
			}
		} else if (this._containerMulti.parentNode) {
			this._containerMulti.replaceWith(this._container.label);
		}
	}

	_showPopup() {
		this._containerMulti.firstChild.replaceWith(this._iconOpen);
		this._popup.classList.add("open");
		this._openState = true;
	}

	_hidePopup() {
		this._containerMulti.firstChild.replaceWith(this._iconClosed);
		this._popup.classList.remove("open");
		this._openState = false;
	}
}
